import { IconSvgProps } from "../types";

export const FourSquares = ({ size }: IconSvgProps) => (
    <svg
        width={size}
        id="icon-object-foursquares"
        height={size}
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        <path d="M12 0H0V12H12V0Z" fill="#1868DB" />
        <path d="M12 16H0V28H12V16Z" fill="#1868DB" />
        <path d="M16 0H28V12H16V0Z" fill="#1868DB" />
        <path d="M28 16H16V28H28V16Z" fill="#1868DB" />
    </svg>
);
